// extracted by mini-css-extract-plugin
module.exports = {"prewievWrap":"linkPrev__prewievWrap__3utXV","prevFrame":"linkPrev__prevFrame__3it5A"};